import { render, staticRenderFns } from "./areaTree.vue?vue&type=template&id=6bf3ca71&scoped=true"
import script from "./areaTree.vue?vue&type=script&lang=js"
export * from "./areaTree.vue?vue&type=script&lang=js"
import style0 from "./areaTree.vue?vue&type=style&index=0&id=6bf3ca71&prod&scoped=true&lang=css"
import style1 from "./areaTree.vue?vue&type=style&index=1&id=6bf3ca71&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf3ca71",
  null
  
)

export default component.exports